import * as Yup from 'yup';

const objectIdRegex = /^[a-f\d]{24}$/i;

const defaultAuditor = {
    email: '',
    password: '',
    two_factor_enabled: false,
    first_name: '',
    last_name: '',
    mobile: {
        country_code: '',
        number: '',
    },
    company_id: '',
    status: true,
    reminder_hours: 24,
};

export const auditorSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email')
        .required('Email is required'),
    password: Yup.string()
        .required('Password is required'),
    two_factor_enabled: Yup.boolean(),
    first_name: Yup.string()
        .required('First name is required'),
    last_name: Yup.string()
        .required('Last name is required'),
    mobile: Yup.object().shape({
        country_code: Yup.string(),
        number: Yup.string()
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
            .required('Mobile number is required'),
    }),
    company_id: Yup.string()
        .matches(objectIdRegex, 'Invalid Company ID')
        .required('Company ID is required'),
    status: Yup.boolean()
        .required('Status is required'),
    reminder_hours: Yup.number()
        .typeError('Reminder hours must be a number')
        .min(0, 'Reminder hours cannot be negative')
        .required('Reminder hours is required'),
});

export const updateAuditorSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email'),
    two_factor_enabled: Yup.boolean(),
    first_name: Yup.string(),
    last_name: Yup.string(),
    mobile: Yup.object().shape({
        country_code: Yup.string(),
        number: Yup.string()
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits'),
    }),
    company_id: Yup.string()
        .matches(objectIdRegex, 'Invalid Company ID'),
    status: Yup.boolean(),
    reminder_hours: Yup.number()
        .typeError('Reminder hours must be a number')
        .min(0, 'Reminder hours cannot be negative'),
});

export const getValidationSchema = (modal) => {
    if (modal === 'add') {
        return auditorSchema;
    } else if (modal === 'edit') {
        return updateAuditorSchema;
    }
    return auditorSchema;
};

export const getInitialValues = (modal, selectedItem) => {
    if (modal === 'add') {
        return {
            ...defaultAuditor,
        };
    } else if (modal === 'edit' && selectedItem) {
        return {
            email: selectedItem.email || '',
            two_factor_enabled: selectedItem.two_factor_enabled ?? false,
            first_name: selectedItem.first_name || '',
            last_name: selectedItem.last_name || '',
            mobile: {
                country_code: selectedItem.mobile?.country_code || '',
                number: selectedItem.mobile?.number || '',
            },
            company_id: selectedItem.company_id || '',
            status: selectedItem.status ?? true,
            reminder_hours: selectedItem.reminder_hours ?? 24, 
        };
    }

    return {
        ...defaultAuditor,
    };
};